/**
 * Логика гидроизоляции: вид по енаму и по id из ссылки каталога.
 */
import { waterproofSection } from "./catalog";
import { WaterproofMaterial, type WaterproofCatalogItem } from "./types";

export const DEFAULT_WATERPROOF_MATERIAL: WaterproofMaterial = WaterproofMaterial.Coating;

/** Вид гидроизоляции из каталога; неизвестный — первый, чтобы комната не осталась без заливки. */
export const getWaterproofMaterial = (material: WaterproofMaterial): WaterproofCatalogItem =>
	waterproofSection.items.find((item) => item.material === material) ?? waterproofSection.items[0];

/** Вид по строковому id из ссылки каталога (`CatalogRef.item`). */
export const waterproofItemById = (id: string): WaterproofCatalogItem | null =>
	waterproofSection.items.find((item) => item.id === id) ?? null;
